import * as yup from 'yup';

const changePasswordFormSchema = yup.object().shape({
  currentPassword: yup.string().required('Current password is mandatory'),
  newPassword: yup
    .string()
    .required('New password is mandatory')
    .matches(
      /^(?!\s+)(?!.*\s+$)(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[$^*.[\]{}()?"!@#%&/\\,><':;|_~`=+\- ])[A-Za-z0-9$^*.[\]{}()?"!@#%&/\\,><':;|_~`=+\- ]{8,256}$/,
      'Your password must contain at least 8 characters, 1 uppercase letter, 1 number (0-9), 1 special character'
    ),
  confirmPassword: yup
    .string()
    .required('Confirm password is mandatory')
    .oneOf([yup.ref('newPassword')], 'Passwords do not match'),
});

const changePasscodeFormSchema = yup.object().shape({
  currentPassword: yup
    .string()
    .required('Current passcode is mandatory')
    .matches(/^\d{6}$/, 'Your passcode must contain exactly 6 numbers'),
  newPassword: yup
    .string()
    .required('New passcode is mandatory')
    .matches(/^\d{6}$/, 'Your passcode must contain exactly 6 numbers'),
  confirmPassword: yup
    .string()
    .required('Confirm passcode is mandatory')
    .oneOf([yup.ref('newPassword')], 'Passcodes do not match'),
});

export default changePasswordFormSchema;
export { changePasscodeFormSchema };
